import EndPointConfig from '../../models/api/endPointConfig';

const controller = 'Languages';

/// Define all EndPoints for login agents methods.
export const LanguagesEP: EndPointConfig[] = [
    // Get datos para el token de usuario
    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)
        .setActionName('webagent')
        .setAlias('GetAgentLanguages'),
    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)
        .setActionName('backoffice')
        .setAlias('GetAgentLanguagesForUsers'),

];
